(() => {
  const triggerSelector = '[data-vspots-guarantee-trigger]';

  function closeDialog(dialog) {
    if (dialog?.open) dialog.close();
  }

  function bindTrigger(trigger) {
    if (trigger.dataset.vspotsGuaranteeBound === 'true') return;
    trigger.dataset.vspotsGuaranteeBound = 'true';

    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog) return;

    trigger.addEventListener('click', () => dialog.showModal());
    dialog.querySelector('[data-vspots-guarantee-close]')?.addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
  }

  function initialize(scope = document) {
    if (scope.matches?.(triggerSelector)) bindTrigger(scope);
    scope.querySelectorAll?.(triggerSelector).forEach(bindTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
